import { makeAutoObservable } from "mobx";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";
import { notification } from "antd";

class HomePageStorage {
  dronesByStatus: Record<string, number> = {};

  financials: {
    ordersTotal: 0,
    ordersTotalByItems: 0,
    receivedOrdersTotal: 0,
    "inStockOrdersTotal": 0,
    "notReceivedOrdersTotal": 0,
    "inProgress": 0,
    "income": 0,
    "totalBalance": 0,
    "spentBalance": 0,
    "usedBalance": 0,
  };

  constructor() {
    makeAutoObservable(this);
  }

  loadStats = async () => {
    try {
      const response = await RestApiQuery.get<any>(ApiEndpoints.OrderStats);
      this.dronesByStatus = response.drones.dronesByStatus;
      this.financials = response.financials;
    } catch (error: any) {
      notification.error({ message: error.message });
    }
  }
}

const homePageStorage = new HomePageStorage();

export default homePageStorage;
